import { useSelector } from "react-redux";

import Icon from "./Icon";
import Currency, { ConvertCurrency } from "../helpers/Currency/Currency";
import {
  convertPaymentGatewayToLogo,
  convertPaymentGatewayToText,
  paymentGatewayItems,
} from "../utils/enum";

const PaymentGateway = ({ value, onChange, onBlur }) => {
  const auth = useSelector((state) => state.auth);
  const user = useSelector((state) => state.user);

  const handleChange = (val) => {
    onChange(val);
    onBlur && onBlur();
  };
  return (
    <>
      <div className="d-flex align-items-center flex-wrap gap-2">
        {paymentGatewayItems?.map((option) => (
          <label
            htmlFor={option}
            className="bg-neutral-50 px-20 py-12 radius-8 w-100"
          >
            <span className="form-check checked-light d-flex align-items-center gap-2">
              <input
                className="form-check-input"
                type="radio"
                name="paymentGateway"
                id={option}
                checked={option === value}
                onChange={() => handleChange(option)}
                onBlur={onBlur}
              />
              <img
                src={convertPaymentGatewayToLogo(option)}
                alt={convertPaymentGatewayToText(option)}
                className="img-fluid rounded"
                width={25}
              />
              <span className="form-check-label line-height-1 fw-medium text-secondary-light text-line-1">
                {convertPaymentGatewayToText(option)}
              </span>
            </span>
          </label>
        ))}
      </div>
      <div className="alert alert-warning bg-warning-50 text-warning-500 border-warning-100 py-1 mt-3 text-sm radius-10">
        <div className="d-flex align-items-center gap-2">
          <Icon icon="solar:danger-triangle-linear" />
          <span>
            در صورت فعال بودن VPN لطفا نسبت به غیرفعالسازی آن اقدام نمایید
          </span>
        </div>
      </div>
      {!auth.isAdmin && (
        <div className="alert alert-secondary bg-secondary-50 text-secondary-500 border-secondary-100 py-1 mt-1 text-sm radius-10">
          <div className="d-flex align-items-center gap-2">
            <Icon icon="solar:danger-triangle-linear" />
            <span>
              موجودی فعلی کیف پول <ConvertCurrency price={user.wallet} />{" "}
              <Currency />
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentGateway;
